import { bookingCancel } from './bookingCancel';
import { bookingResponse } from './bookingResponse';
import { checkoutResponse } from './checkoutResponse';
import { coreReady } from './coreReady';
import { ratesResponse } from './ratesResponse';

export const ProviderGTM = {
  bookingCancel,
  bookingResponse,
  checkoutResponse,
  coreReady,
  ratesResponse,
};
